import React, { useMemo } from 'react'

export function DocsTemplatesPreview({ state }) {
  const { documents, docMessages } = state

  const getRecipientEmail = (recipientId) => {
    const recipient = state.recipients.find((recipient) => recipient.id == recipientId)
    return recipient ? recipient.profile.email : ''
  }

  // Filter out messages for unselected documents
  const filteredDocMessages = useMemo(() => {
    const messagesByRecipients = {}

    if (!docMessages) return messagesByRecipients

    Object.keys(docMessages).forEach((recipientId) => {
      if (documents[recipientId]) {
        messagesByRecipients[recipientId] = documents[recipientId].reduce((acc, doc) => {
          acc[doc.value] = docMessages?.[recipientId]?.[doc.value]
          return acc
        }, {})
      }
    })

    return messagesByRecipients
  }, [documents, docMessages])

  return (
    <>
      <div className='grid gap-3'>
        {Object.keys(filteredDocMessages).map((recipientId) => (
          <div key={recipientId}>
            <h1 className='text-xl font-semibold mb-2'>{getRecipientEmail(recipientId)}</h1>
            <div className='prose prose-sm border rounded-lg shadow bg-gray-50 p-5'>
              <div className='grid gap-3'>
                {Object.entries(filteredDocMessages[recipientId])
                  .sort(([a], [b]) => b.localeCompare(a))
                  .map(([docType, message]) => (
                    <div key={docType}>
                      <p className='text-base font-semibold text-sky-700 mb-1'>
                        {documents[recipientId].find((d) => d.value.toString() === docType)?.label}
                      </p>
                      <div
                        className='border rounded-lg shadow bg-white p-3'
                        dangerouslySetInnerHTML={{ __html: message }}
                      />
                    </div>
                  ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}
